export default __webpack_public_path__ + "static/media/header-restaurant.bf35b370.jpg";